import React, { useState } from 'react';
import { contactInfo } from '../data/mock';
import { Mail, Calendar } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import BookingModal from './BookingModal';
import ContactModal from './ContactModal';

const CTASection = () => {
  const [isBookingOpen, setIsBookingOpen] = useState(false);
  const [isContactOpen, setIsContactOpen] = useState(false);
  const { t } = useLanguage();

  return (
    <section id="contact" className="py-16 cta-gradient">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center">
          {/* Header */}
          <h2 className="text-3xl md:text-4xl font-extrabold text-[#0d1442] mb-4">
            {t('cta.title')}
          </h2>
          <p className="text-lg text-slate-600 mb-8">
            {t('cta.subtitle')}
          </p>

          {/* Contact Cards - always 2 columns */}
          <div className="grid grid-cols-2 gap-4 sm:gap-6 mb-10">
            {/* Book Consultation */}
            <button
              onClick={() => setIsBookingOpen(true)}
              className="card-hover bg-white rounded-2xl p-6 border border-slate-100 shadow-sm text-center w-full transition-all hover:shadow-lg"
              data-testid="cta-book-btn"
            >
              <div className="icon-badge w-14 h-14 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <Calendar className="w-6 h-6 text-[#1a237e]" />
              </div>
              <h3 className="text-sm font-semibold text-slate-500 uppercase tracking-wider mb-2">{t('cta.book')}</h3>
              <span className="text-lg font-bold text-[#1a237e]">
                {t('cta.consultation')}
              </span>
            </button>

            {/* Email - now opens contact modal */}
            <button
              onClick={() => setIsContactOpen(true)}
              className="card-hover bg-white rounded-2xl p-6 border border-slate-100 shadow-sm text-center w-full transition-all hover:shadow-lg"
              data-testid="cta-email-btn"
            >
              <div className="icon-badge w-14 h-14 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <Mail className="w-6 h-6 text-[#1a237e]" />
              </div>
              <h3 className="text-sm font-semibold text-slate-500 uppercase tracking-wider mb-2">{t('cta.email')}</h3>
              <span className="text-lg font-bold text-[#1a237e]">
                {contactInfo.email}
              </span>
            </button>
          </div>

          <p className="text-sm text-slate-500">
            {t('cta.response')}
          </p>
        </div>
      </div>

      {/* Booking Modal */}
      <BookingModal 
        isOpen={isBookingOpen} 
        onClose={() => setIsBookingOpen(false)} 
      />

      {/* Contact Modal */}
      <ContactModal 
        isOpen={isContactOpen} 
        onClose={() => setIsContactOpen(false)} 
      />
    </section>
  );
};

export default CTASection;
